import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/reducers';
import { selectConfiguration } from '../../store/selectors';

export const selectClientState = createSelector(
  (state: RootState) => state,
  (state) => state.clients
);

export const selectLinkedAccounts = createSelector(selectConfiguration, (configuration) => configuration?.linkedAccounts);

export const selectReportSettings = createSelector(selectConfiguration, (configuration) => configuration?.reportSettings);

export const selectConstraints = createSelector(selectConfiguration, (configuration) => configuration?.constraints);

export const selectTargets = createSelector(selectConfiguration, (configuration) => configuration?.targets);

export const selectDetails = createSelector(selectConfiguration, (configuration) => configuration?.details);

export const selectActivation = createSelector(selectConfiguration, (configuration) => configuration?.activation);
